import xlsx from "json-as-xlsx";
import moment from 'moment';

const ListadoSeguimientosExportar = (content) => {
    let columns = [
        { label: 'ID Vaca', value: 'id_vaca' },
        { label: 'Proveedor', value: 'nombre_proveedor' },
        { label: 'ID UGRJ', value: 'id_ugrj' },
        { label: 'ID Margarita', value: 'id_margarita' },
        { label: 'Rancho', value: 'rancho' },
        { label: 'Vaca', value: 'vaca' },
        { label: 'Evento', value: 'evento' },
        { label: 'Evento Detalle', value: 'evento_detalle' },
        { label: 'Evento Fecha', value: 'evento_fecha' },
        { label: 'Notificación', value: 'notificacion' },
        { label: 'Fecha Notificación', value: 'fecha_notificacion' },
        { label: 'Pregunta', value: 'pregunta' },
        { label: 'Completada', value: 'completada' },
        { label: 'Fecha Completada', value: 'completada_fecha' }
      ];
      
      let settings = {
        sheetName: 'Seguimiento_Vacas_Detalle',
        fileName: 'Seguimiento_Vacas_Detalle_' + moment().format("YYYYMMDD_HHmmss"),
        extraLength: 3,
        writeOptions: {}
      }
      
     xlsx(columns, content, settings, true);
  };
  export default ListadoSeguimientosExportar;
